import React from 'react';
import type { Moment } from 'moment';
import moment from 'moment';
import { Button } from '@this/shared/ui/inputs/button';
import type HotelElement from '@this/src/domain/hotel_element2';
import CancelLimit from '@this/domain/cancel_limit2';
import { observer } from 'mobx-react';

import CancelLimitFormItem from './cancel_limit_form_item';

interface Props {
  hotelElement: HotelElement;
  checkinDate: Moment;
  classNameForModifiedField: (...path: (string | number)[]) => string;
}

const CancelLimitFormComponent = ({ hotelElement, checkinDate, classNameForModifiedField }: Props) => {
  const cancelLimits = hotelElement.cancelLimits;
  const timezone = cancelLimits[0]?.limitDatetimeTimezone;
  const utcOffset = cancelLimits[0]?.utcOffset;
  const timezoneLabel = cancelLimits.length > 0 ? cancelLimits[0].timeZoneLabel : null;

  const handleRemoveCancelLimit = (cancelLimit: CancelLimit) => {
    hotelElement.removeCancelLimit(cancelLimit);
  };

  return (
    <>
      <div className="virtual-counte-price-change-form__input-wrapper" style={{ alignItems: 'flex-start' }}>
        <label className="virtual-counte-price-change-form__label">キャンセルポリシー</label>
        {hotelElement.cancelLimits.length === 0 ? (
          <CancelLimitAddButton
            hotelElement={hotelElement}
            checkinDate={checkinDate}
            timezone={timezone}
            utcOffset={utcOffset}
          />
        ) : (
          timezoneLabel && <label style={{ marginLeft: '8px' }}>({timezoneLabel})</label>
        )}
      </div>
      {hotelElement.cancelLimits.length > 0 && (
        <div className="virtual-counte-price-change-form__input-wrapper-item">
          <div>
            {cancelLimits.map((cancelLimit, index) => (
              <CancelLimitFormItem
                key={cancelLimit.id ? `cancel-limit-${cancelLimit.id}` : `cancel-limit-new-${index}`}
                cancelLimit={cancelLimit}
                index={hotelElement.cancelLimits.indexOf(cancelLimit)}
                checkinDate={checkinDate}
                classNameForModifiedField={classNameForModifiedField}
                onRemove={handleRemoveCancelLimit}
              />
            ))}
            <CancelLimitAddButton
              hotelElement={hotelElement}
              checkinDate={checkinDate}
              timezone={timezone}
              utcOffset={utcOffset}
            />
          </div>
        </div>
      )}
    </>
  );
};

const CancelLimitAddButton = ({
  hotelElement,
  checkinDate,
  timezone,
  utcOffset
}: {
  hotelElement: HotelElement;
  checkinDate: Moment;
  timezone?: string;
  utcOffset?: number;
}) => (
  <Button
    size="small"
    style={{ marginLeft: 0 }}
    onClick={() => {
      const currentTimezone = timezone || 'Asia/Tokyo';
      const date = moment(checkinDate).tz(currentTimezone);
      const newLimit = new CancelLimit({
        cancelFeePercent: 0,
        cancelFeeAmount: 0,
        cancelFeeNights: 0,
        limitDatetime: date.startOf('day').utc(),
        limitDatetimeTimezone: currentTimezone,
        noShow: false,
        utcOffset
      });
      hotelElement.addCancelLimit(newLimit);
    }}
  >
    追加
  </Button>
);

const CancelLimitForm = observer(CancelLimitFormComponent);

export default CancelLimitForm;
